import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import { User } from 'src/app/core/services/group/group.model';

@Component({
  selector: 'app-group-view-member',
  templateUrl: './group-view-member.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupViewMemberComponent {
  @Input() isAdminView: boolean;
  @Input() isMe: boolean;
  @Input() user: User;

  private _isOpen = false;

  @Output() groupViewMemberProfileConnect = new EventEmitter<number>();
  @Output() groupViewMemberProfileDisconnect = new EventEmitter<number>();
  @Output() groupViewMemberUpdateToModerator = new EventEmitter<number>();
  @Output() groupViewMemberUpdateToMember = new EventEmitter<number>();

  get isModerator() {
    return this.user.is_moderator;
  }

  get isMember() {
    return !this.user.is_moderator;
  }

  get isOpen() {
    return this._isOpen;
  }

  onOpen() {
    if (!this.isAdminView || this.isMe) {
      return;
    }

    this._isOpen = !this._isOpen;
  }

  onProfileConnect() {
    this.groupViewMemberProfileConnect.emit(this.user.id);
  }

  onProfileDisconnect() {
    this.groupViewMemberProfileDisconnect.emit(this.user.id);
  }

  updateToModerator() {
    this.groupViewMemberUpdateToModerator.emit(this.user.id);
  }

  updateToMember() {
    this.groupViewMemberUpdateToMember.emit(this.user.id);
  }
}
